@if (proof) {
  <aside class="proof-panel" data-testid="proof-panel" (click)="$event.stopPropagation()">
    <div class="proof-head">
      <span class="status-chip" [class]="'status-chip ' + badge">{{ badgeLabel }}</span>
      <span class="proof-note">{{ sourceNote }}</span>
    </div>

    @for (row of rows; track row.label) {
      <div class="section">
        <span class="label">{{ row.label }}</span>
        @if (row.label.startsWith('Position') && mapsLink) {
          <a class="value link" [href]="mapsLink" target="_blank" rel="noopener">{{ row.value }}</a>
        } @else {
          <span class="value" [class.ok]="row.tone === 'ok'" [class.bad]="row.tone === 'bad'">{{ row.value }}</span>
        }
      </div>
    }

    @if (picture?.stamped_url) {
      <div class="section stamped">
        <span class="label">Stamped copy</span>
        <span class="value">
          {{ showingOriginal ? 'Showing the original.' : 'Showing the stamped copy.' }}
          <a class="link" href="javascript:void(0)" (click)="toggleOriginal.emit()" data-testid="toggle-original">
            {{ showingOriginal ? 'View stamped' : 'View original' }}
          </a>
        </span>
        <button mat-stroked-button color="primary" class="proof-stamped" (click)="downloadStamped()" data-testid="download-stamped">
          <mat-icon>download</mat-icon>
          Download stamped copy
        </button>
      </div>
    }
  </aside>
}
